const api = process.env.REACT_APP_API_BASE_URI;

export function GetBaseApiEndPoint() {
  return api;  
}
